import { escapeDown } from 'services/listeners';

import { TCallback, useKeyDown, useKeyDownControlled } from './useKeyDown';

export const useEscapeDown = (callback: TCallback, target?: boolean) =>
  useKeyDown(escapeDown, callback, target);

export const useEscapeDownControlled = (callback: TCallback) =>
  useKeyDownControlled(escapeDown, callback);
